var _ = require("lodash");

module.exports = _.assign(
    /** @lends module:Lambda# */
    {
      /** exports {@link module:Lambda.Reductions} namespace. */
      Reduction: require("./Lambda/Reductions"),
      /** alias to {@link module:Lambda.Reductions~reduce}. */
      reduce: require("./Lambda/Reductions").reduce,
      /** alias to {@link module:Lambda.reduceLambdaObject}. */
      reduceLambdaObject: require("./Lambda/reduceLambdaObject"),
      /** exports {@link module:Lambda.Constructors} namespace. */
      Constructors: require("./Lambda/Constructors"),
      /** alias to {@link module:Lambda.LambdaTermId}. */
      LambdaTermId: require("./Lambda/LambdaTermId"),
      /** alias to {@link module:Lambda.Lambda-object~LambdaObjectId}. */
      LambdaId: require("./Lambda/Lambda-object").LambdaObjectId
    },
    require("./Lambda/Externals"),
    require("./Lambda/JSON"),
    require("./Lambda/Predicates"),
    require("./Lambda/Lambda-object")
  );
